import React from 'react';
import ReactModal from 'react-modal';
import translate from './translate';

function Popup({
    strings,
    contactOpen,
    helpOpen,
    onCloseContact,
    onCloseHelp,
}) {
    return (
        <div>
            <ReactModal
                isOpen={contactOpen}
                onRequestClose={onCloseContact}
                portalClassName="modal-portal"
                overlayClassName="modal-overlay"
                className="modal-modal popup-window white-popup-block"
                contentLabel="Contact"
            >
                <h1 className="headline1">{strings.contact.title}</h1>
                <hr className="divider" />
                <h3 className="font-md">WeWash GmbH</h3>
                <p className="mt-10">
                    Sendlinger-Tor-Platz 10
                    <br />
                    80336 München
                </p>
                <h3 className="font-md spacer">{strings.contact.email}</h3>
                <p className="mt-10">info@we-wash.com</p>
                <h3 className="font-md spacer">{strings.contact.callUs}</h3>
                <p className="mt-10">{strings.help.phone}</p>
                <button
                    className="mfp-close icon icon-wew-close icon-sm"
                    onClick={onCloseContact}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                />
            </ReactModal>

            <ReactModal
                isOpen={helpOpen}
                onRequestClose={onCloseHelp}
                portalClassName="modal-portal"
                overlayClassName="modal-overlay"
                className="modal-modal popup-window white-popup-block"
                contentLabel="Help"
            >
                <h1 className="headline1">{strings.help.title}</h1>
                <hr className="divider" />
                <h3 className="font-md">{strings.help.text1}</h3> <br />
                <h3 className="font-md">{strings.help.emailtitle}</h3>
                <p className="mt-10">{strings.help.email}</p>
                <h3 className="font-md">{strings.help.phonetitle}</h3>
                <p className="mt-10">{strings.help.phone}</p>
                <button
                    className="mfp-close icon icon-wew-close icon-sm"
                    onClick={onCloseHelp}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                />
            </ReactModal>
        </div>
    );
}

export default translate('Popup')(Popup);
